import {
  Button,
  Checkbox,
  Divider,
  Form,
  Image,
  Input,
  Space,
  Typography,
} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import logo from '../../../../Assets/pnFin.png';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { UserLoginSuccessResponse } from '../../../../Models/Response/Authentication/Otp';
import {
  sendOtp,
  verifyOtp,
} from '../../../../Services/AuthenticationServices/AuthenticationServices';
import { setCredentialsLocalStorage } from '../../../../Services/LocalStorageServices';
import { LoginSignupFormType } from '../../../../Utils/Constants/loginSignupFormTypes';
import { Routes } from '../../../../Utils/Constants/routes';
import getIsRedirection from '../../../../Utils/redirectionUtility';
import PinInputComponent from '../../../Common/Components/PinInput';
import UserIdentification from '../../../Identifiers/UserIdentification';
import ForgotPassword from '../ForgotPassword';
import UserInformation from '../UserInformation';

import './index.css';
interface ILoginSignupFormProps {
  formType: string;
  formSubmit: (values: any) => void;
  buttonSubSectionText: string;
  buttonSubSectionButton: string;
  className?: string;
  subButtonClick: () => void;
  buttonText: string;
  isLoginWithPin?: (is: boolean) => void;
  phoneNumber?: string;
  isOtpInputVisible?: boolean;
  onResendOtp: (values: any) => void;
}

enum FormType {
  LOGIN = 'LOGIN',
  CreateAccount = 'Create Account',
}

const LoginSignupForm: React.FC<ILoginSignupFormProps> = ({
  className,
  isLoginWithPin,
  children,
  formType,
  formSubmit,
  buttonSubSectionButton,
  buttonSubSectionText,
  buttonText,
  subButtonClick,
  phoneNumber,
  isOtpInputVisible,
  onResendOtp,
}) => {
  const [isLoginWithPinState, setIsLoginWithPin] = useState(true);
  const [disableInputPhoneNumber, setDisableInputPhoneNumber] = useState(false);
  const [form] = Form.useForm();
  const [token, setToken] = useState('');
  const [otpUniqueID, setOTPUniqueId] = useState('');
  const loading: boolean = useSelector(
    (state: any) => state.loader.searchLoader
  );
  const [visible, setVisibility] = useState(false);
  const [isAddIdentifierVerification, setVerification] = useState(false);
  const { push } = useHistory();
  const { t } = useTranslation();
  const otpResendDuration = 30;
  const [counter, setCounter] = useState(otpResendDuration);
  const timer = useRef<any>();

  useEffect(() => {
    if (counter <= 0) {
      clearTimeout(timer.current);
      return;
    }
    timer.current = setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  const onMobileChange = (e: any) => {
    if (e.target.value[0] === '0') {
      e.target.value = e.target.value.substring(1);
    }
    e.target.value = e.target.value.replace(/[^0-9]/gi, '');
  };

  useEffect(() => {
    if (!!phoneNumber && phoneNumber.length === 10) {
      form.setFieldsValue({ phoneNumber });
      setDisableInputPhoneNumber(true);
      formSubmit({ phoneNumber });
    }
  }, [phoneNumber]);

  const onResend = () => {
    onResendOtp({ phoneNumber: form.getFieldValue('phoneNumber') });
  };
  const loginWithPin = () => {
    setIsLoginWithPin(!isLoginWithPinState);

    // tslint:disable-next-line: no-unused-expression
    isLoginWithPin && isLoginWithPin(!isLoginWithPinState);
    if (isLoginWithPinState) {
      form.setFieldsValue({ pin: '' });
    }
  };

  const checkVuaId = (_: any, value: string) => {
    if (
      value &&
      value.length === 10 &&
      Number(value) &&
      value !== form.getFieldValue(LoginSignupFormType.phoneNumber)
    ) {
      return Promise.reject(
        new Error('10 digit vuaId must be same as mobile number')
      );
    }
    return Promise.resolve();
  };

  const setVuaIdAsMobileNumber = (change: any) => {
    const phoneNumberField = change.filter(
      (c: any) => c.name.toString() === LoginSignupFormType.phoneNumber
    )[0];
    const vuaIdField = change.filter(
      (c: any) => c.name.toString() === LoginSignupFormType.vuaId
    )[0];
    // tslint:disable-next-line: no-unused-expression
    phoneNumberField &&
      phoneNumberField.touched &&
      phoneNumberField.value &&
      phoneNumberField.value.length === 10 &&
      !vuaIdField &&
      form.setFieldsValue({ vuaId: phoneNumberField.value });
  };

  const onCancel = () => {
    setVisibility(false);
    setVerification(false);
  };

  const onIdentifierEntered = (iNumber: any) => {
    sendOtp({ phoneNumber: iNumber.value, isResetPin: true })
      .then((res) => res.data)
      .then((res) => {
        setVerification(true);
        setOTPUniqueId(res);
      });
  };

  const onOTPSubmit = (otp: string, identifierNumber: any) => {
    setToken('');
    verifyOtp({
      phone_number: identifierNumber.value,
      grant_type: 'password',
      code: otp,
      otpUniqueID,
      isTermsAndConditionAgreed: true,
      isResetPin: true,
    })
      .then((res) => res.data)
      .then((res: UserLoginSuccessResponse) => {
        form.resetFields();
        setVisibility(false);
        setVerification(false);
        setCredentialsLocalStorage(res);
        setToken(res.access_token);
      });
  };

  const renderTerms = () => {
    push(Routes.terms);
  };

  const renderPrivacy = () => {
    push(Routes.privacy);
  };

  return (
    <>
      {token && <ForgotPassword token={token} />}
      <UserIdentification
        handleCancel={onCancel}
        identifierEntered={onIdentifierEntered}
        isAddIdentifierVerification={isAddIdentifierVerification}
        onOTPSubmit={onOTPSubmit}
        visible={visible}
        label={'Enter Mobile Number'}
        multipleIdentifiers={false}
      />
      <div className='detailsForm flexCommonCss'>
        <Form
          form={form}
          className='form'
          name='basic'
          onFinish={formSubmit}
          autoComplete='off'
          onFieldsChange={setVuaIdAsMobileNumber}
          scrollToFirstError={true}
        >
          <div className={`${className} flexCommonCss formBodyInput`}>
            <Image src={logo} preview={false} />
            <Typography.Text className='formTypeText'>
              {formType}
            </Typography.Text>
            <Form.Item
              className='inputCss formItemMarginBotton'
              name={LoginSignupFormType.phoneNumber}
              rules={[
                {
                  required: true,
                  message: '* Required field',
                },
                {
                  len: 10,
                  message: 'Mobile number should be of 10 digits',
                },
              ]}
            >
              <Input
                style={{ width: '100%' }}
                id='mobile'
                type='tel'
                onInput={onMobileChange}
                maxLength={10}
                placeholder='Mobile Number'
                disabled={disableInputPhoneNumber}
              />
            </Form.Item>
            {!!phoneNumber ? (
              isOtpInputVisible ? (
                <>
                  <Form.Item
                    className='inputCss formItemMarginBotton'
                    name='otp'
                    rules={[
                      {
                        required: true,
                        message: '* Required field',
                      },
                      {
                        len: 6,
                        message: 'Invalid OTP',
                      },
                    ]}
                  >
                    <Input
                      style={{ width: '100%' }}
                      id='otp'
                      type='password'
                      onInput={onMobileChange}
                      maxLength={6}
                      placeholder='OTP'
                    />
                  </Form.Item>
                  <Button
                    disabled={counter !== 0}
                    className='primaryButton'
                    id='resendButton'
                    type='text'
                    onClick={onResend}
                  >
                    {t('RESEND')} {counter !== 0 && `in ${counter}`}
                  </Button>
                </>
              ) : (
                <></>
              )
            ) : (
              isLoginWithPinState &&
              formType === FormType.LOGIN && (
                <Space
                  className='inputCss'
                  split={<Divider style={{ height: 40 }} type='vertical' />}
                >
                  <PinInputComponent className='test' />
                  <Typography.Text
                    style={{
                      width: 'auto',
                      cursor: 'pointer',
                      color: 'var(--ant-primary-color)',
                    }}
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick={() => setVisibility(true)}
                  >
                    Forgot Password?
                  </Typography.Text>
                </Space>
              )
            )}
            {!getIsRedirection() && formType === FormType.LOGIN && (
              <Typography.Text
                className='loginPin inputCss'
                onClick={loginWithPin}
              >
                {!isLoginWithPinState
                  ? t('Login With Pin')
                  : t('Login With OTP')}
              </Typography.Text>
            )}
            {!getIsRedirection() && formType === FormType.CreateAccount && (
              <UserInformation vuaIdValidator={checkVuaId} />
            )}

            {children}

            <Form.Item
              valuePropName='checked'
              rules={[
                {
                  validator: (_, checked) => {
                    if (!checked) {
                      return Promise.reject(
                        new Error(t('Please agree to Terms and Conditions'))
                      );
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
              name={'isTermsAndConditionAgreed'}
              initialValue={formType === FormType.LOGIN ? true : false}
            >
              <Checkbox className='checkBox' id='isTermsAndConditionAgreed'>
                <Typography.Text className='agreed'>
                  {t('I agree to')}{' '}
                  <Typography.Link
                    // onClick={renderTerms}
                    href='https://qa.pbfintechaa.com/account-aggregator/term-and-condition'
                    target='_blank'
                    className='termsAndCondition'
                  >
                    {t('Terms & Conditions')}
                  </Typography.Link>{' '}
                  {'&'}{' '}
                  <Typography.Link
                    href='https://qa.pbfintechaa.com/account-aggregator/privacy-policy'
                    // onClick={renderPrivacy}
                    target='_blank'
                    className='termsAndCondition'
                  >
                    {t('Privacy Policy')}
                  </Typography.Link>
                </Typography.Text>
              </Checkbox>
            </Form.Item>
          </div>
          <div className='flexCommonCss formFooter'>
            <Form.Item className='otpButton formItemMarginBotton'>
              <Button
                loading={loading}
                className='commonButtonBackground primaryButton formItemButton'
                htmlType='submit'
              >
                {(!isLoginWithPinState && formType === FormType.LOGIN) ||
                formType === FormType.CreateAccount
                  ? buttonText
                  : t(FormType.LOGIN)}
              </Button>
            </Form.Item>
            {!disableInputPhoneNumber && (
              <>
                <Typography.Text className='donthaveaccountText primaryButton'>
                  {buttonSubSectionText}
                </Typography.Text>

                <Button
                  className='primaryButton'
                  onClick={subButtonClick}
                  id='createAccountButton'
                  type='text'
                >
                  {buttonSubSectionButton}
                </Button>
              </>
            )}
          </div>
        </Form>
      </div>
    </>
  );
};

export default LoginSignupForm;
